function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.65 4.7C5.58888 4.7 6.35 3.93888 6.35 3C6.35 2.06112 5.58888 1.3 4.65 1.3C3.71112 1.3 2.95 2.06112 2.95 3C2.95 3.93888 3.71112 4.7 4.65 4.7ZM4.65 6C6.30685 6 7.65 4.65685 7.65 3C7.65 1.34315 6.30685 0 4.65 0C2.99315 0 1.65 1.34315 1.65 3C1.65 4.65685 2.99315 6 4.65 6Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.5 3C6.5 2.64102 6.79102 2.35 7.15 2.35H15.15C15.509 2.35 15.8 2.64102 15.8 3C15.8 3.35898 15.509 3.65 15.15 3.65H7.15C6.79102 3.65 6.5 3.35898 6.5 3Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 3C0 2.64102 0.291015 2.35 0.65 2.35H1.65C2.00899 2.35 2.3 2.64102 2.3 3C2.3 3.35898 2.00899 3.65 1.65 3.65H0.65C0.291015 3.65 0 3.35898 0 3Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.15 8.3C10.2111 8.3 9.45 9.06112 9.45 10C9.45 10.9389 10.2111 11.7 11.15 11.7C12.0889 11.7 12.85 10.9389 12.85 10C12.85 9.06112 12.0889 8.3 11.15 8.3ZM11.15 7C9.49315 7 8.15 8.34315 8.15 10C8.15 11.6569 9.49315 13 11.15 13C12.8069 13 14.15 11.6569 14.15 10C14.15 8.34315 12.8069 7 11.15 7Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.3 10C9.3 10.359 9.00899 10.65 8.65 10.65L0.650004 10.65C0.291019 10.65 4.04558e-06 10.359 4.07697e-06 10C4.10835e-06 9.64101 0.291019 9.35 0.650004 9.35L8.65 9.35C9.00899 9.35 9.3 9.64102 9.3 10Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8 10C15.8 10.359 15.509 10.65 15.15 10.65H14.15C13.791 10.65 13.5 10.359 13.5 10C13.5 9.64102 13.791 9.35 14.15 9.35H15.15C15.509 9.35 15.8 9.64102 15.8 10Z"
});

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.3f02af0e.svg";
export { ForwardRef as ReactComponent };